
import React, { PureComponent } from 'react';
import utils from 'services/utils';

import Language from 'services/Language.js';

import CustomInputClearifier from '../component/CustomInputClarifier';
import classNames from 'class-names';

const DELETE_DELAY_TIMEOUT = 500;
const DELETE_DELAY_TIME_INTERVAL = 60;

const funcStub = () => { };

class ModalPINForm extends PureComponent {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleCloseKeyboard = this.handleCloseKeyboard.bind(this);
        this.handleKeyBoardOnClear = this.handleKeyBoardOnClear.bind(this);
        this.handleOpenKeyboard = this.handleOpenKeyboard.bind(this);
        this.handleKeyBoardPress = this.handleKeyBoardPress.bind(this);
        // this.handleKeyBoardBackspace = this.handleKeyBoardBackspace.bind(this);
        this.handleKeyBoardFinish = this.handleKeyBoardFinish.bind(this);

        this.handleBackspaceStart = this.handleBackspaceStart.bind(this);
        this.handleBackspaceEnd = this.handleBackspaceEnd.bind(this);

        this.handleInputClicked = this.handleInputClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handlePreventDefault = this.handlePreventDefault.bind(this);

        this.backspaceDescriptor = null;

        this.state = {
            showClear: false,
            isKeyBoardOpened: false,
            firstOpenKeyBoard: false,
            pin: "",
            isInvalid: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        const prevState = state.prevState;
        return {
            isInvalid: (prevState && state.isInvalid) ? prevState.pin === state.pin : state.isInvalid,
            prevState: state
        };
    }

    handleKeyPress(event) {
        event.preventDefault();
        return false;
    }

    handleChange(event) {
        this.setState({
            pin: event.target.value,
        });
    }

    handleCloseKeyboard() {
        this.setState({
            isKeyBoardOpened: false,
        });
        // this.props.onKeyBoardSwitch({opened: false});
    }

    handleOpenKeyboard(event) {
        this.setState({
            isKeyBoardOpened: true,
        });
        // this.props.onKeyBoardSwitch({opened: true});
    }

    handleKeyBoardPress(event) {
        const target = event.target;
        const value = target.getAttribute("data-value");

        // this.refs.input.refs.input.blur();
        // this.refs.input.refs.input.focus();

        this.setState({
            pin: this.state.pin + value
        });
    }

    componentWillUnmount() {
        clearTimeout(this.backspaceDescriptor);
        clearInterval(this.backspaceDescriptor);
    }

    handleBackspaceStart() {
        this.backspaceDescriptor = setTimeout(() => {
            this.backspaceDescriptor = setInterval(() => {
                this.handleKeyBoardBackspace();
            }, DELETE_DELAY_TIME_INTERVAL);
        }, DELETE_DELAY_TIMEOUT);
    }

    handleBackspaceEnd() {

        clearTimeout(this.backspaceDescriptor);
        clearInterval(this.backspaceDescriptor);

        // this.refs.input.refs.input.blur();
        // this.refs.input.refs.input.focus();

        this.handleKeyBoardBackspace();
    }

    handleKeyBoardBackspace() {
        this.setState({
            pin: this.state.pin.slice(0, -1),
        });
    }

    handleKeyBoardFinish() {
        this.handleCloseKeyboard();
    }

    handleKeyBoardOnClear() {
        this.setState({
            pin: '',
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.pin) {
            // this.refs.input.refs.input.focus();
            this.setState({
                isInvalid: true,
            });
            return;
        }
        this.props.onSubmit({
            text: this.state.pin,
            handlerId: this.props.handlerId
        });
    }

    handlePreventDefault(event) {
        event.preventDefault();
        return false;
    }

    setCarriageToEnd() {
        const value = this.refs.input.refs.input.value;
        if (typeof this.refs.input.refs.input.setSelectionRange === 'function') {
            this.refs.input.refs.input.setSelectionRange(value.length, value.length);
        }
    }

    handleInputClicked() {
        this.setCarriageToEnd();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.disableTabs !== this.props.disableTabs &&
            !!prevProps.disableTabs) {
            $(this.refs.container).find(':focus').blur();
        }
        if(((this.props.isLast && this.props.step === this.props.handlers.length - 1) || (!this.props.isLast && this.props.step === this.props.handlers.length - 2)) && !this.state.firstOpenKeyBoard){
            this.setState({
                isKeyBoardOpened: true,
                firstOpenKeyBoard: true
            });
        }
    }

    getTabIndex() {
        return this.props.disableTabs ? "-1" : "";
    }

    getPending() {
        return !!this.props.pending;
    }

    render() {
        return (
            <div className="modal-verification-new__body-pin">
                <h2 className="modal-verification-new__title-pin text text--size-body-bold-large" dangerouslySetInnerHTML={{ __html: Language.getLabel('L_CONFIRM_HEADER_PIN') }}>
                </h2>
                <div className="modal-verification-new__lead-pin text text--size-body-medium text--color-gray" dangerouslySetInnerHTML={{ __html: Language.getLabel('L_CONFIRM_SUB_HEADER_PIN') }}>
                </div>
                <form className="modal-verification-new__form-pin" onSubmit={this.handleSubmit}>
                    <div className="modal-verification-new__enter-pin">
                        <CustomInputClearifier
                            ref="input"
                            showClear={this.state.isKeyBoardOpened}
                            additionalClassName={(!this.state.isKeyBoardOpened ? "keyboard-ico" : "")}
                            additionalClassNameInput={classNames({
                                'readonly-editable': true,
                                '_focus': !!this.state.isKeyBoardOpened,
                                'is-invalid': this.state.isInvalid
                            })}
                            disabled={this.getPending()}
                            onChange={this.handleChange}
                            onFocus={this.handleOpenKeyboard}
                            onBlur={funcStub}
                            onClear={this.handleKeyBoardOnClear}
                            onTouchEnd={utils.isMobile() ? this.handleInputClicked : funcStub}
                            onMouseUp={utils.isMobile() ? funcStub : this.handleInputClicked}
                            onKeyPress={this.handleKeyPress}
                            onCut={this.handlePreventDefault}
                            onPaste={this.handlePreventDefault}
                            onCopy={this.handlePreventDefault}
                            placeholder={Language.getLabel('L_CONFIRM_PLACEHOLDER_PIN')}
                            name="phone"
                            tabIndex={this.getTabIndex()}
                            value={this.state.pin}
                            type="password"
                            readOnly={true}
                        />
                        {!!this.state.isKeyBoardOpened &&
                            <div className="modal-verification-new__number-keyboard-pin number-keyboard">
                                <div className="number-keyboard__row">
                                    <button className="number-keyboard__cell"
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        data-value="1"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >1</button><button
                                        className="number-keyboard__cell"
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        data-value="2"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >2</button><button
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        className="number-keyboard__cell"
                                        data-value="3"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >3</button>
                                </div>
                                <div className="number-keyboard__row">
                                    <button
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        className="number-keyboard__cell"
                                        data-value="4"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >4</button><button
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        className="number-keyboard__cell"
                                        data-value="5"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >5</button><button
                                        tabIndex={this.getTabIndex()}
                                        disabled={this.getPending()}
                                        className="number-keyboard__cell"
                                        data-value="6"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                    >6</button>
                                </div>
                                <div className="number-keyboard__row">
                                    <button className="number-keyboard__cell"
                                        data-value="7"
                                        onClick={this.handleKeyBoardPress}
                                        disabled={this.getPending()}
                                        type="button"
                                        tabIndex={this.getTabIndex()}
                                    >7</button><button
                                        className="number-keyboard__cell"
                                        data-value="8"
                                        onClick={this.handleKeyBoardPress}
                                        disabled={this.getPending()}
                                        type="button"
                                        tabIndex={this.getTabIndex()}
                                    >8</button><button
                                        className="number-keyboard__cell"
                                        data-value="9"
                                        onClick={this.handleKeyBoardPress}
                                        disabled={this.getPending()}
                                        type="button"
                                        tabIndex={this.getTabIndex()}
                                    >9</button>
                                </div>
                                <div className="number-keyboard__row">
                                    <button className="number-keyboard__cell number-keyboard__cell--error"
                                        onMouseDown={utils.isMobile() ? funcStub : this.handleBackspaceStart}
                                        onMouseUp={utils.isMobile() ? funcStub : this.handleBackspaceEnd}
                                        onTouchStart={utils.isMobile() ? this.handleBackspaceStart : funcStub}
                                        onTouchEnd={utils.isMobile() ? this.handleBackspaceEnd : funcStub}
                                        type="button"
                                        disabled={this.getPending()}
                                        tabIndex={this.getTabIndex()}>
                                        <svg className="icon icon--delete-pin" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M4.67079 16L10.417 9.5H27.5002V22.5H10.417L4.67079 16ZM9.44249 8.33767C9.6323 8.12296 9.90511 8 10.1917 8H28.0002C28.5525 8 29.0002 8.44772 29.0002 9V23C29.0002 23.5523 28.5525 24 28.0002 24H10.1917C9.90511 24 9.6323 23.877 9.44248 23.6623L3.25421 16.6623C2.91982 16.2841 2.91982 15.7159 3.25421 15.3377L9.44249 8.33767ZM13.9812 19C13.771 19.2079 13.771 19.545 13.9812 19.7529L14.0734 19.8441C14.2836 20.052 14.6244 20.052 14.8345 19.8441L17.86 16.8513L20.8854 19.8441C21.0956 20.052 21.4364 20.052 21.6465 19.8441L21.7387 19.7529C21.9489 19.545 21.9489 19.2079 21.7387 19L18.7133 16.0072L21.7533 13C21.9635 12.7921 21.9635 12.455 21.7533 12.2471L21.6611 12.1559C21.451 11.948 21.1102 11.948 20.9 12.1559L17.86 15.1631L14.8199 12.1559C14.6097 11.948 14.269 11.948 14.0588 12.1559L13.9666 12.2471C13.7564 12.455 13.7564 12.7921 13.9666 13L17.0066 16.0072L13.9812 19Z" />
                                        </svg>
                                    </button>
                                    <button className="number-keyboard__cell"
                                        data-value="0"
                                        onClick={this.handleKeyBoardPress}
                                        type="button"
                                        disabled={this.getPending()}
                                        tabIndex={this.getTabIndex()}
                                    >0</button>
                                    <button className="number-keyboard__cell number-keyboard__cell--succes"
                                        type="submit"
                                        disabled={this.getPending()}
                                        tabIndex={this.getTabIndex()}>
                                        <svg className="icon icon--succes-pin" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M25.4 16C25.4 21.1915 21.1915 25.4 16 25.4C10.8085 25.4 6.6 21.1915 6.6 16C6.6 10.8085 10.8085 6.6 16 6.6C21.1915 6.6 25.4 10.8085 25.4 16ZM27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10 16.4999L14.0003 20L14.0011 19.9993L15.143 19.0002L22 12.9998L20.8573 12L14.0015 17.9986L11.1427 15.5001L10 16.4999Z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                    {!this.state.isKeyBoardOpened &&
                        <div className="modal-verification-new__list-buttons">
                            <button className="btn-new btn-new--block"
                                type="submit"
                                disabled={this.getPending()}
                                tabIndex={this.getTabIndex()}>
                                {this.props.isLast ?
                                    Language.getLabel('L_SEND') :
                                    Language.getLabel('L_NEXT')
                                }
                            </button>
                            <button className="btn-new btn-new--outline btn-new--block"
                                type="button"
                                data-dismiss="modal"
                                tabIndex={this.getTabIndex()}
                                disabled={this.getPending()}
                                onClick={this.props.onCancel}>
                                {Language.getLabel('L_CANCEL')}
                            </button>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

export default ModalPINForm;